import React from "react";
import TopBar from "../components/TopBar";
import "../App.css";

const About = () => {
  return (
    <>
      {/* Sky blue background wrapper */}
      <div style={{ background: "#d1e8fd", display: "flex", flexDirection: "column", alignItems: "center" }}>
        {/* Width-constrained container for TopBar */}
        <div style={{ maxWidth: "1120px", width: "100%"}}>
                <TopBar
        breadcrumb="About"
        breadcrumbStyle={{
            maxWidth: "1080px",
            width: "100%"
        }}
        />

        </div>
      </div>

      {/* About content */}
      <div className="home-wrapper">
        <div className="home-container">
          <h1>About This Project</h1>
          <p className="sidebar-description-left">
            This platform is still in active construction. We’re building it step by step and your feedback is essential to shape it into something that truly helps.
          </p>
          <p className="sidebar-description-left">
            This site was created by someone who has lived with chronic pain for nearly a decade. The frustration of being left in the dark — with no clear information about which treatments help, which don’t, which can make things worse, and which alternative options might be worth trying — is what inspired this project.
          </p>
          <p className="sidebar-description-left">
            Our goal is to cut through confusion and give people access to what the research actually shows, all on one single platform. That means highlighting not just the possible benefits, but also the real consequences: side effects, invasiveness, financial costs, and whether insurance usually covers it. 
          </p>
          <p className="sidebar-description-left">
            Because this project is still evolving, we need your help. Please share your feedback, your thoughts, and what would make this tool more useful for you or others living with chronic pain. Together we can build a resource that makes navigating treatments clearer, safer, and more empowering.
          </p>
          <p className="sidebar-description-left">
            Thank you for being part of this journey. You deserve clarity, control, and hope — and we’re committed to helping make that possible.
          </p>
        </div>
      </div>
    </>
  );
};

export default About;
